module.exports = __webpack_public_path__ + "static/media/payment_failed.ec2fc09a.png";